import { render, staticRenderFns } from "./VisitRecord.vue?vue&type=template&id=8303756c&scoped=true"
import script from "./VisitRecord.vue?vue&type=script&lang=js"
export * from "./VisitRecord.vue?vue&type=script&lang=js"
import style0 from "./VisitRecord.vue?vue&type=style&index=0&id=8303756c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8303756c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8303756c')) {
      api.createRecord('8303756c', component.options)
    } else {
      api.reload('8303756c', component.options)
    }
    module.hot.accept("./VisitRecord.vue?vue&type=template&id=8303756c&scoped=true", function () {
      api.rerender('8303756c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/VisitRecord.vue"
export default component.exports